import React from "react";
import ReactDOM from "react-dom";
import { findCompanyDetail } from "../../../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../../../commons/show-error-message";
import ParametersSection from "../../components/ParametersSection";
import { logError, addContextLog } from "../../../../infrastructure/log";
import {
  translate,
  getLanguage,
} from "../../../../infrastructure/translate/localization";
import { MonetaryAmount } from "../../../../app/domain/monetary-amount";

export function renderParametersSection({
  company,
  mealBenefit,
  transportBenefit,
  nurseryBenefit,
  model,
  recurrentSubsidy,
  mealDays,
  mealAmount,
  transportAmount,
  nurseryAmount,
}) {
  let formattedBalance = "- €";
  if (company) {
    const langTag = getLanguage();
    formattedBalance = MonetaryAmount.ofCurrency({
      ...company.balance,
    }).prettifyMoney({ langTag });
  }

  const target = document.getElementById("parameters-section-container");
  if (target) {
    ReactDOM.render(
      <ParametersSection
        balance={formattedBalance}
        model={model}
        mealBenefit={mealBenefit}
        transportBenefit={transportBenefit}
        nurseryBenefit={nurseryBenefit}
        recurrentSubsidy={recurrentSubsidy}
        mealDays={mealDays}
        mealAmount={mealAmount}
        transportAmount={transportAmount}
        nurseryAmount={nurseryAmount}
        countryISO2Code={company.countryISO2Code}
      />,
      target
    );
  }
}

export async function displayParameters({ model, recurrentSubsidy = false }) {
  try {
    const { data } = await findCompanyDetail();

    let mealDays = 20;
    let mealAmount = 0;
    let transportAmount = 0;
    let nurseryAmount = 0;

    if (model.subsidy) {
      model.subsidy.generalParameters.forEach((generalParameter) => {
        if (generalParameter.category === "meal-benefit") {
          mealDays = generalParameter.days;
          mealAmount = generalParameter.amount.amountInCents / 100;
        } else if (generalParameter.category === "transport-benefit") {
          transportAmount = generalParameter.amount.amountInCents / 100;
        } else if (generalParameter.category === "nursery-benefit") {
          nurseryAmount = generalParameter.amount.amountInCents / 100;
        }
      });
    }

    renderParametersSection({
      company: data,
      mealBenefit: model.mealBenefit,
      transportBenefit: model.transportBenefit,
      nurseryBenefit: model.nurseryBenefit,
      model,
      recurrentSubsidy,
      mealDays,
      mealAmount,
      transportAmount,
      nurseryAmount,
    });
    addContextLog("info", "displayParameters", "display-screen", {
      companyId: data.id,
      modelId: model.id,
      recurrentSubsidy,
    });
  } catch (e) {
    logError(e, `Error to displayParameters in model ${model}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
